module.exports = __webpack_public_path__ + "img/icons.5b6905a6.svg";